import assignToThis from '../../helper/assignToThis';
import { ObjectOnly } from '@/classes/ObjectOnly';

export class EcoBreakdown {

  // PV

    public pvModule: number | null = null;

    public pvRackSystem: number | null = null;

    public pvInverter: number | null = null;

    public pvInverterAcdcRatio: number | null = null;

    public pvLogisticAndTransport: number | null = null;

    public otherAntiInjectionDevice: number | null = null;

    public otherAcBillOfService: number | null = null;

    public otherDcBillOfService: number | null = null;

    public otherLogisticAndTransport: number | null = null;

    public pvStructureCivilWorks: number | null = null;

    public pvStructureShelter: number | null = null;

    public projectInstallationPriceFixed: number | null = null;

    public pvMechanicalInstallation: number | null = null;

    public pvElectricalInstallation: number | null = null;

    public projectAffiliatesAndHq: number | null = null;

    public projectEngineeringAndAdministrative: number | null = null;

    public projectEpcMargin: number | null = null;

    public projectSupervision: number | null = null;

    // Generator

    public generatorBeforeDayCost: number | null = null;

    public generatorBeforeNightCost: number | null = null;

    public generatorBeforeLogisticAndTransport: number | null = null;

    public generatorAfterDayCost: number | null = null;

    public generatorAfterNightCost: number | null = null;

    public generatorAfterLogisticAndTransport: number | null = null;

    public generatorCostType1: number | null = null; // multi

    public generatorCostType2: number | null = null; // multi

    public generatorLogisticAndTransport: number | null = null; // multi

    // Battery

    public batteryModule: number | null = null;

    public batteryPriceReduction: number | null = null;

    public batteryInverter: number | null = null;

    public batteryLogisticAndTransport: number | null = null;

    public batteryStructureCivilWorks: number | null = null;

    public batteryStructureShelter: number | null = null;

    public batteryMechanicalInstallation: number | null = null;

    public batteryElectricalInstallation: number | null = null;

    public constructor(obj: ObjectOnly = {}) {
      assignToThis(this, obj);
    }

}
